import { CrewMerchantUi } from 'corso-types';
import { z } from 'zod';
import { useParsedStickySearchParams } from '~/providers/StickySearchParams';

const { widgetRefSchema, tokenAuthSchema } = CrewMerchantUi;

export type WidgetRef = z.infer<typeof widgetRefSchema>['ref'];
/**
 * Hook to access the referring widget integration from the sticky search parameters.
 * Returns either the `ref` value if it was available; otherwise, returns `null`.
 * So, this can be used outside of token auth, but will always be `null` in those cases.
 */
export function useWidgetRef() {
  return useParsedStickySearchParams(widgetRefSchema)?.ref ?? null;
}

/**
 * Hooks to access the widget authentication information from the sticky search parameters.
 * Returns either the auth information if it was available; otherwise, returns `null`.
 */
export function useWidgetAuth() {
  return useParsedStickySearchParams(tokenAuthSchema);
}

/** Utility hook to help identify if the UI is embedded within a CRM for the Corso Concierge team. */
export function useIsConciergeWidget() {
  const ref = useWidgetRef();
  return ref === 'corso-concierge';
}
